export default __webpack_public_path__ + "static/media/noun_monthly calendar_1589933.4187206a.svg";